import CodiceFiscale from "codice-fiscale-js";
import { PROVINCE } from "codice-fiscale-js/src/lista-province";
import { COMUNI } from "codice-fiscale-js/src/lista-comuni";
import toast from "svelte-french-toast";

export function getProvinceSelectList() {
    return Object.keys(PROVINCE).map((key) => ({ label: PROVINCE[`${key}`], value: key }))
}

export function getFilteredComuniList() {
    return COMUNI.map((c) => ({ province: c[1], label: c[2], value: c[0] }));
}

export function filterComuni(label, filterText, option, province) {
    return option.province === province && (!filterText || label.toLowerCase().includes(filterText.toLowerCase()));
}

export function generateFiscalCode(subscriberData) {
    try {
        const bd = new Date(subscriberData.birthDate);

        const fiscalCode = new CodiceFiscale({
            name: normalizeAccents(subscriberData.firstName),
            surname: normalizeAccents(subscriberData.lastName),
            gender: subscriberData.gender === "MALE" ? "M" : "F" ,
            day: bd.getDate(),
            month: bd.getMonth() + 1,
            year: bd.getFullYear(),
            birthplace: subscriberData.birthPlace.label,
            birthplaceProvincia: subscriberData.birthProvince.value,
        });

        return fiscalCode.toString();
    } catch (e) {
        console.error(e);

        if (e.toString().includes("not a valid date")) {
            toast.error("Impossibile calcolare il codice fiscale, data di nascita errata");
        } else if (e.toString().includes("comune") || e.toString().includes("prov")) {
            toast.error("Impossibile calcolare il codice fiscale, comune e provincia errati");
        } else {
            toast.error("Impossibile calcolare il codice fiscale");
        }

        return "";
    }
}

function normalizeAccents(str) {
    return str.toLowerCase()
        .replace("à", "a")
        .replace("è", "e")
        .replace("ì", "i")
        .replace("ò", "o")
        .replace("ù", "u");
}

export function validateFiscalCode(fiscalCode) {
    try {
        const codiceFiscale = new CodiceFiscale(fiscalCode);

        return codiceFiscale.isValid();
    } catch (e) {
        return false;
    }
}
